module.exports = __webpack_public_path__ + "static/media/collab.e0917f34.jpg";